import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button } from '@drifthq/tide-core'
import InstallSnippetCard from 'components/OnboardingInstallSnippetCard'
import { SNIPPET_TYPES } from 'layouts/OnboardingInstallStep/constants'
import { getEmbedSnippet } from 'modules/org/selectors'

import './style.css'

const mapStateToProps = (state) => {
  return {
    embedSnippet: getEmbedSnippet(state) || ''
  }
}

class Snippet extends Component {
  static propTypes = {
    installType: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
  }

  getSnippet() {
    const { embedSnippet } = this.props

    return `<!-- Start of Async Drift Code -->\n${embedSnippet.trim()}\n<!-- End of Async Drift Code -->`
  }

  renderCopy() {
    const { installType } = this.props
    const wordPressCopyText = "Copy the code below and head over to your WordPress Admin Panel. After installing the Drift WordPress plugin, you should see a link to it in your Dashboard. Click Settings > Drift > and then paste this code in the field."

    const copyElement = installType === SNIPPET_TYPES.WORDPRESS ? <span> {wordPressCopyText} </span> :
      <span className="install-snippet-copy">
        Paste the code below before the <code>&lt;/head&gt;</code> tag on every page you want Drift to appear. For more detailed help, <a href="https://help.drift.com/article/install-drift-on-your-website-javascript/" target="_blank" rel="noopener noreferrer">click here</a>.
    </span>
    return (
      <Fragment>{copyElement}</Fragment>
    )
  }

  onClickVerifyButton = () => {
    const { history, path } = this.props
    history.push(path + '/verify')
  }

  render() {
    return (
      <div className="install-snippet-wrapper">
        <div className="install-snippet-body">
          {this.renderCopy()}
          <InstallSnippetCard snippet={this.getSnippet()} />
          <p className="install-snippet-doc-link">
            Want to identify your users?
            <a href="https://devdocs.drift.com/docs/contact-properties#section-driftidentifyuserid-attributes" target="_blank" rel="noopener noreferrer"> Read more here.</a>
          </p>
        </div>
        <Button className="install-snippet-verify-button" size="large" onClick={this.onClickVerifyButton}>
          Verify installation
        </Button>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Snippet)


// WEBPACK FOOTER //
// ./src/components/OnboardingInstallSnippet/index.js